module.exports = __webpack_public_path__ + "static/media/FOR-BUSD.a2413527.svg";